import { render, staticRenderFns } from "./CurrentChargesTab.vue?vue&type=template&id=0b6d70a2&scoped=true"
import script from "./CurrentChargesTab.vue?vue&type=script&lang=js"
export * from "./CurrentChargesTab.vue?vue&type=script&lang=js"
import style0 from "./CurrentChargesTab.vue?vue&type=style&index=0&id=0b6d70a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d70a2",
  null
  
)

export default component.exports